import { SVG } from '@svgdotjs/svg.js'
import scrollama from "scrollama";
import { animateConultancyHeaderStart } from "./consultancyHeaderAnims";

animateConultancyHeaderStart();



// Animate on scroll
const pathRefOnScroll = SVG('#branch-1-path-5');
// const plantSvgBg = SVG(".svg-background");
const plantSvgBg = SVG()
        .addTo('.plant-based-background')
        .attr({class: "svg-background"});

const plantBaseElRef = document.querySelector(".svg-background");

pathRefOnScroll.stroke({ 
        opacity: 0
});


const consultancySvgBg = SVG(".consultancy-background svg");


// instantiate the scrollama
const scroller = scrollama();

// setup the instance, pass callback functions
scroller
.setup({
        step: ".section-plant-based",
        offset: 0.9
})
.onStepEnter((response) => {
        pathRefOnScroll.attr({class: "path-anim-slow"});
        const pathRefOnScrollLen = pathRefOnScroll.length();
        pathRefOnScroll.stroke({ 
                opacity: 1,
                dasharray: pathRefOnScrollLen, 
                dashoffset: pathRefOnScrollLen
        });
        let pathEndViewbox = pathRefOnScroll.pointAt(pathRefOnScrollLen);
        let pathEndNorm = pathEndViewbox.x/consultancySvgBg.viewbox().w;
        let pathEndXtoNewSvg = pathEndNorm*window.innerWidth;
        // let pathEndNorm = pathEndViewbox.x;
        setTimeout(() => {


                var outstretchPath = plantSvgBg
                        .path(`
                        m ${pathEndXtoNewSvg},-50 
                        c 0,-10 
                        0,30 
                        0,0
                `).attr("class", "not-on-safari")
                .animate(400).ease("-").plot(`
                m ${pathEndXtoNewSvg},50 
                c 0,-10 
                0,30 
                0,50
        `       )
        .after(function(){
                const xOffsets = [0, 45, 90];

                xOffsets.forEach(function(offset){
                        var bottomLeaf = plantSvgBg
                                .path(`m ${pathEndXtoNewSvg-offset},100 c 1.02317,35.72951 -20.85645,59.47437 -56.5659,60.98511`);
        
                        bottomLeaf.attr({class: "leaf-anim"});
                        const bottomLeafLength = bottomLeaf.length();
                        bottomLeaf.stroke({ 
                                dasharray: bottomLeafLength, 
                                dashoffset: bottomLeafLength
                        });
        
                        var topLeaf = plantSvgBg
                                .path(`m ${pathEndXtoNewSvg-offset},100 c -35.73574,1.51185 -57.63147,25.27418 -56.60754,61.02999`);
        
                        topLeaf.attr({class: "leaf-anim"});
                        topLeaf.stroke({ 
                                dasharray: bottomLeafLength, 
                                dashoffset: bottomLeafLength
                        });
                });



        })
        // Shrink out extension
        .animate(300).plot(`
                m ${pathEndXtoNewSvg},100 
                c 0,0 
                0,0 
                0,0
        `);
               

        }, 1400);
  });







window.addEventListener("resize", () => {
        scroller.resize();
        // Remove all animated leafs as new animations may come on scroll
        const animatedLeafParent = document.querySelector(".svg-background");
        while (animatedLeafParent.firstChild) {
                animatedLeafParent.removeChild(animatedLeafParent.firstChild);
        }
});  
